import host from "../config/host";
const ajaxUrl =
  process.env.NODE_ENV !== "production"
    ? `${host.dev}/api`
    : `${host.prod}/api`;
//${host.auth}
const authUrl = `${host.auth}/api`; // process.env.NODE_ENV !== 'production' ? `${host.dev}/api` : `${host.auth}/api`;
export const hr_download = `${host.hr}/api/`; // process.env.NODE_ENV === 'development' || process.env.VUE_APP_PROJECT_ENV === 'stage' ? 'https://cyamis-staging.baicizhan.com/api/' : 'https://cyamis.baicizhan.com/api/'
// payee_company_account/select_search
export const util_api = {
  dev_login: "common/dev_login",
  base_info: "common/base_info",
  check_system_update: "common/check_system_update",
  check_profile_completed: "common/check_profile_completed",
  common_dev_auto_login: "common/dev_auto_login",
  // common
  common_search_customer_path: "common/search_customer",
  common_customer_net: "common/customer_net",
  common_customer_net_info: "common/customer_net_info",
  get_customer_infos: "get_customer_infos",
  update_customer_intro: "customer_info/update_intro",
  get_companies_path: "company/get_companies",
  company_update: "company/update",
  // team
  team_leader_list: "team/leader_list",
  get_teams_path: "team/get_teams",
  team_tree_info: "team/tree_info",
  team_update: "team/update",
  team_delete: "team/delete",
  upload_team_avatar: `${ajaxUrl}/team/upload_avatar`,
  parent_teams: "team/parent_teams",
  team_formal_customers: "team/formal_customers",
  get_fin_teams: "fin_team/get_all",
  get_fin_team_and_group: "fin_team/team_and_group",
  fin_team_update: "fin_team/update",
  my_team_info: "team/my_team",
  update_team_fin_team: "fin_team/update_team",
  fin_team_expense_data: "fin_team/expense_data",
  fin_team_write_off_data: "fin_team/write_off_data",
  team_tree: "team/l2_tree",

  // fin team group
  update_fin_team_group: "fin_team_group/update",
  fin_report_header_data: "fin_team_group/groups_and_none_group_teams",

  // team fin customer
  team_fin_customer_list: "team_fin_customer/list",
  update_team_fin_customer: "team_fin_customer/update",

  // job
  get_jobs_path: "job/get_jobs",
  job_update: "job/update",
  job_delete: "job/delete",
  // recruit job
  query_recruit_job: "recruit_job/query",
  update_recruit_job: "recruit_job/update",
  del_recruit_job: "recruit_job/delete",
  // recruit need
  query_recruit_need: "recruit_need/query",
  query_my_recruit_need: "recruit_need/query_mine",
  update_recruit_need: "recruit_need/update",
  delete_recruit_need: "recruit_need/delete",
  recruit_need_detail: "recruit_need/detail",
  // recruit type
  get_all_recruit_types: "recruit_type/get_all",
  // office map
  office_map_list: "office_map/list",
  office_map_update: "office_map/update",
  office_map_locate: "office_map/locate",
  office_map_location: "office_map/location",
  // customer
  update_customer: "customer/update_customer",
  customer_select_search: "customer/select_search",
  query_customer: "customer/query_customer",
  query_team_customer: "customer/team_customer",
  batch_set_customer_team: "customer/batch_set_team",
  query_customer_name: "customer/query_name",
  query_customer_with_team: "customer/query_with_team",
  query_customer_with_team_company: "customer/query_with_team_company",
  query_customer_with_contact: "customer/query_with_contact",
  query_customer_with_customer_account: "customer/query_with_customer_account",
  query_customer_travel_order_info: "travel_order/customer_info",
  query_customer_for_batch_operation: "customer/query_for_batch_operation",
  query_director: "customer/query_director",
  es_query_formal_customer: "customer/es_query_formal",
  es_query_informal_customer: "customer/es_query_informal",
  get_customers_path: "customer/query",
  customer_detail: "customer/detail",
  find_customer: "customer/find",
  update_customer_nickname: "customer/update_nickname",
  update_customer_wechat_number: "customer/update_wechat_number",
  update_customer_qq_number: "customer/update_qq_number",
  get_formal_interns: "customer/formal_interns",
  generate_auth_extra: "customer/generate_auth_extra",
  customer_activity_badges: "customer/activity_badges",
  //customer info
  material_alert: "customer_info/material_alert",
  upload_avatar: `${ajaxUrl}/customer_info/upload_avatar`,
  upload_candid_photo: `${ajaxUrl}/customer_info/upload_candid_photo`,
  // customer account
  query_customer_account: "customer_account/query",
  query_informal_alipay: "customer_account/query_informal_alipay",
  update_customer_account: "customer_account/update",
  // school mate
  query_schoolmate: "schoolmate/query",
  update_schoolmate: "schoolmate/update",
  //pre customer
  query_pre_customer: "pre_customer/query",
  update_pre_customer: "pre_customer/update",
  turn_into_customer: "pre_customer/turn_into_customer",
  delete_pre_customer: "pre_customer/delete",
  //home page
  get_home_pages: "home_page/get_all",
  add_home_page: "home_page/add",
  //customer home page
  update_customer_home_page: "customer_home_page/update",
  delete_customer_home_page: "customer_home_page/delete",
  my_customer_home_pages: "customer_home_page/my_home_pages",
  //customer interest
  add_customer_interest: "customer_interest/add",
  delete_customer_interest: "customer_interest/delete",
  // batch operation
  batch_set_director: "batch_operate/batch_set_director",
  batch_set_team: "batch_operate/batch_set_team",

  get_my_informal_path: "informal/my_informal",
  query_informal_intern: "informal/query_intern",
  add_customer_to_wage_records:
    "director_informal_wage_topic/add_customer_to_wage_records",
  informal_wage_topics_path: "informal_wage_topic/list",
  my_informal_wage_topic_record: "director_informal_wage_topic/topic_record",
  director_informal_wage_topic_batch_add_customer:
    "director_informal_wage_topic/batch_add_customer",
  team_informal_wage_topic_detail_path: "informal_wage_topic/team_detail",
  informal_wage_topic_detail: "informal_wage_topic/detail",
  informal_wage_topic_update: "informal_wage_topic/update",
  informal_wage_topic_notices: "informal_wage_topic/notices",

  informal_wage_topic_record_detail_add:
    "director_informal_wage_topic/add_record_detail",
  informal_wage_topic_record_detail_update:
    "director_informal_wage_topic/update_record_detail",
  informal_wage_topic_record_detail_list:
    "director_informal_wage_topic/detail_list",

  informal_wage_topic_update_status_confirm:
    "informal_wage_topic/update_status_confirm",
  update_informal_wage_topic_status: "informal_wage_topic/update_status",
  informal_wage_topic_director_topics: "informal_wage_topic/director_topics",
  director_informal_wage_topic_send_notice:
    "director_informal_wage_topic/send_notice",
  update_informal_wage_records: "director_informal_wage_topic/update_records",
  import_informal_wage_records: "director_informal_wage_topic/import_records",
  change_informal_director: "informal/change_director",
  change_informal_daily_wage: "informal/change_daily_wage",
  informal_wage_record_update_desc: "informal_wage_record/update_desc",
  del_wage_record: "informal_wage_record/delete",
  update_informal_wage: "informal_wage_record/update",
  abandon_informal_wage: "informal_wage_record/abandon",
  recover_informal_wage: "informal_wage_record/recover",
  update_informal_wage_record_cur_daily_wage:
    "informal_wage_record/update_cur_daily_wage",
  update_informal_wage_record_bank_info:
    "informal_wage_record/update_bank_info",
  update_director_topic_status: "director_informal_wage_topic/update_status",
  update_director_topics_status:
    "director_informal_wage_topic/update_topics_status",
  director_informal_wage_records: "director_informal_wage_topic/records",
  delete_director_informal_wage_topic: "director_informal_wage_topic/delete",
  recover_director_informal_wage_topic: "director_informal_wage_topic/recover",
  director_informal_wage_topic_audit:
    "director_informal_wage_topic/audit_topics",
  director_informal_wage_topic_batch_pass:
    "director_informal_wage_topic/batch_pass",
  director_informal_wage_topic_batch_fail:
    "director_informal_wage_topic/batch_fail",
  director_informal_wage_topic_export_template:
    "director_informal_wage_topic/export_template",
  // director_informal_wage_topic_imort_records: 'director_informal_wage_topic/imort_records',
  //formal intern
  query_fi_wage_topic: "fi_wage_topic/query",
  update_fi_wage_topic: "fi_wage_topic/update",
  get_fi_wage_records: "fi_wage_topic/records",
  add_fi_wage_record: "fi_wage_topic/add_record",
  del_fi_wage_record: "fi_wage_topic/del_record",
  save_fi_wage_records: "fi_wage_topic/save_records",
  export_fi_wage_topic: `${ajaxUrl}/fi_wage_topic/export`,

  // intern
  query_intern_with_team_company: "intern/query_with_team_company",
  set_asset_user: "asset/set_user",

  //career
  update_customer_career: "customer/update_career",
  delete_career: "career/delete",
  career_alert: "career/alert",
  //groups
  get_groups: `${authUrl}/group/get_all`, // ok
  group_update: `${authUrl}/group/update`, // 没有地方调用
  group_detail: `${authUrl}/group/detail`, // ok
  group_add_customer: `${authUrl}/group/add_customer`, // bu ok
  group_add_service: `${authUrl}/group/add_service`, // ok
  del_group_customer: `${authUrl}/group/delete_customer`, // ok
  del_group_service: `${authUrl}/group/delete_service`, // ok
  //service
  get_services: `${authUrl}/service/get_all`, // ok
  service_update: `${authUrl}/service/update`, // ok
  // mis group
  get_mis_groups: "mis_group/get_all",
  mis_group_update: "mis_group/update",
  mis_group_detail: "mis_group/detail",
  mis_group_add_customer: "mis_group/add_customer",
  mis_group_del_customer: "mis_group/delete_customer",
  //payee company
  query_payee_company: "payee_company/query",
  query_payee_company_name: "payee_company/query_name",
  query_payee_company_with_account: "payee_company/query_with_account",
  query_payee_company_account: "payee_company/query_account",
  update_payee_company: "payee_company/update",
  delete_payee_company_cooperation_info:
    "payee_company/delete_payee_company_cooperation_info",
  delete_payee_company_contact: "payee_company_contact/delete",
  query_payee_company_withid: "payee_company/query_with_id",
  query_cooperation_infos: "payee_company/query_cooperation_infos",
  find_payee_company: "payee_company/find",
  delete_payee_company_account: "payee_company/delete_account",
  payee_company_query_list: "payee_company/query_list",
  // contract/legal_audit_users
  //asset phone
  update_asset_phone: "asset_phone/update",
  find_phones_with_condition: "asset_phone/find_phones_with_condition",
  delete_phones_by_id: "asset_phone/delete_phones_by_id",
  phone_asset_number_search: "asset_phone/phone_asset_number_search", //查询资产编号,绑定未绑定全部查询出来
  find_details_by_asset_number: "asset_phone/find_details_by_asset_number",
  asset_phone_mobile_info_list: "asset_phone/mobile_info_list",
  asset_phone_update_mobile_account_info:
    "asset_phone/update_mobile_account_info",

  // asset phone numbers
  update_phone_number: "asset_phone_number/update",
  find_phone_numbers_with_condition:
    "asset_phone_number/find_phone_numbers_with_condition",
  delete_phone_number_by_id: "asset_phone_number/delete_phone_number_by_id",
  delete_phone_number_course: "asset_phone_number/delete_phone_number_course",
  phone_number_search: "asset_phone_number/phone_number_search",
  find_details_by_phone_number:
    "asset_phone_number/find_details_by_phone_number",
  // asset_device_account
  update_asset_device_account: "asset_device_account/update",
  find_device_account_with_condition:
    "asset_device_account/find_device_account_with_condition",
  delete_device_account_by_id:
    "asset_device_account/delete_device_account_by_id",
  device_account_search: "asset_device_account/device_account_search",
  find_details_by_device_account:
    "asset_device_account/find_details_by_device_account",
  // relative_details
  update_relative_details: "asset_relative_details/update", //添加或者更新资产绑定关系
  find_relative_details_with_condition:
    "asset_relative_details/find_relative_details_with_condition",
  dis_connect_device_account:
    "asset_relative_details/dis_connect_device_account", //解绑手机账号
  dis_connect_phone_number: "asset_relative_details/dis_connect_phone_number", //解绑手机号
  delete_relative_details_by_id:
    "asset_relative_details/delete_relative_details_by_id", //删除绑定关系，根据id删除
  find_details_by_relative: "asset_relative_details/find_details_by_relative",
  //finance setting
  finance_verify_customers: "finance/verify_customers",
  add_finance_verify_customer: "finance/add_verify_customer",
  del_finance_verify_customer: "finance/del_verify_customer",
  get_expense_payment_banks: "finance/get_expense_payment_banks",
  query_expense_payment_banks: "finance/query_expense_payment_banks",
  update_expense_payment_bank: "finance/update_expense_payment_bank",
  del_expense_payment_bank: "finance/del_expense_payment_bank",
  rmb_central_parities: "finance/rmb_central_parities",
  export_rmb_central_parities: `${ajaxUrl}/finance/export_rmb_central_parities`,
  search_supplier: "finance/search_supplier",
  // bank statement
  query_bank_statement: "bank_statement/query",
  query_bank_statement_item: "bank_statement/query_item",
  bank_statement_item_linked_relations: "bank_statement/item_linked_relations",
  release_bank_statement_item_linked_relations:
    "bank_statement/release_item_linked_relations",
  upload_bank_statement: `${ajaxUrl}/bank_statement/upload_file`,
  expense_group_bank_statements: `bank_statement/expense_group_linked`,
  bank_statements_link_to_expense_group: `bank_statement/link_to_expense_group`,
  expense_group_statement_match_query: "expense_group/statement_match_query",

  bank_statement_upload_file: `${ajaxUrl}/bank_statement/upload_file`,
  bank_statement_sync_item: "bank_statement/sync_item",
  bank_statement_match_rule: "bank_statement/match_rule",
  // bank_statement_rule
  bank_statement_expense_rules: "bank_statement_rule/expense_rules",
  bank_statement_expense_rule_matched_statements:
    "bank_statement_rule/expense_matched_statements",
  update_bank_statement_expense_rule: "bank_statement_rule/update_expense_rule",
  bank_statement_income_rules: "bank_statement_rule/income_rules",
  bank_statement_income_rule_matched_statements:
    "bank_statement_rule/income_matched_statements",
  update_bank_statement_income_rule: "bank_statement_rule/update_income_rule",
  bank_statement_rule_change_expense_status:
    "bank_statement_rule/change_expense_status", // 付款单规则停用启用
  bank_statement_rule_change_income_status:
    "bank_statement_rule/change_income_status",
  //expense group
  query_expense_group: "expense_group/query",
  search_expense_group: "expense_group/search",
  expense_group_statement_match_search: "expense_group/statement_match_search",
  fin_receipt_bill_statement_match_query:
    "fin_receipt_bill/statement_match_query",
  fin_receipt_bill_statement_match_search:
    "fin_receipt_bill/statement_match_search",
  es_query_expense_group: "expense_group/es_query",
  es_query_mine_expense_group: "expense_group/es_query_mine",
  query_expense_group_advance: "expense_group/query_advance",
  query_expense_group_recharge: "expense_group/query_recharge",
  query_expense_group_expense: "expense_group/query_expense",
  query_finished_expense_group_advance: "expense_group/query_finished_advance",
  query_my_expense_group: "expense_group/query_mine",
  query_mine_expense: "expense_group/query_mine_expense",
  query_my_expense_group_advance: "expense_group/query_mine_advance",
  query_my_expense_group_recharge: "expense_group/query_mine_recharge",
  query_expense_group_by_uid: "expense_group/query_by_uid",
  find_expense_group: "expense_group/find",
  expense_group_select_advance_search: "expense_group/select_advance_search",
  expense_group_select_accrual_search: "expense_group/select_accrual_search",
  get_expense_groups_user_flows: "expense_group/user_flows",
  update_expense_group: "expense_group/update",
  expense_group_detail: "expense_group/detail",
  expense_group_detail_items: "expense_group/detail_items",
  expense_group_refund: "expense_group/refund",
  expense_group_relate: "expense_group/query_relate",
  verify_expense_group: "expense_group/verify",
  finish_expense_group: "expense_group/finish",
  batch_finish_expense_group: "expense_group/batch_finish",
  delete_expense_group: "expense_group/delete",
  link_expense_group_advance: "expense_group/link_advance",
  update_expense_group_desc: "expense_group/update_desc",
  update_expense_group_payment_banks: "expense_group/update_payment_banks",
  delete_expense_group_payment_bank: "expense_group/delete_payment_bank",
  gen_invoice_statistic_data: "expense_group/gen_invoice_statistic_data",
  gen_bx_statistic_data: "expense_group/gen_bx_statistic_data",
  gen_accrual_bills: "expense_group/gen_accrual_bills",
  gen_pay_bills: "expense_group/gen_pay_bills",
  expense_group_overflow_price: "expense_group/overflow_price",
  expense_group_transform_batch: "expense_group/transform_batch",
  expense_group_write_off: "expense_group/write_off",
  //expense
  delete_expense: "expense/delete",
  ocr_expense_invoice: ajaxUrl + "/expense/ocr_invoice",
  export_invoice_statistic_data: "expense/export_invoice_statistic_data",
  //expense team
  delete_expense_team: "expense_team/delete",
  //expense type
  get_expense_types: "expense_type/get_all",
  expense_type_name_sorted_types: "expense_type/name_sorted_types",
  expense_type_last_generation_types: "expense_type/last_generation_types",
  expense_type_used_last_generation_types:
    "expense_type/used_last_generation_types",
  update_expense_type: "expense_type/update",

  // income group
  es_query_income_group: "income_group/es_query",
  income_group_detail: "income_group/detail",
  update_income_group: "income_group/update",
  delete_income_group: "income_group/delete",

  // income
  delete_income: "income/delete",

  // receipt_purpose
  update_receipt_purpose: "rec_pay_purpose/update",

  // cash flow type
  get_cash_flow_types: "cash_flow_type/get_all",
  cash_flow_type_name_sorted_types: "cash_flow_type/name_sorted_types",
  cash_flow_type_last_generation_types: "cash_flow_type/last_generation_types",
  update_cash_flow_type: "cash_flow_type/update",
  // expense register
  query_expense_register: "expense_register/query",
  delete_expense_register: "expense_register/delete_invoice_register",
  // customer expense type
  query_customer_expense_type: "customer_expense_type/query",
  update_customer_expense_type: "customer_expense_type/update",
  export_customer_expense_type: "export/customer_expense_type",
  //recharge write off
  query_recharge_payee_companies: "recharge_write_off/query_payee_companies",
  query_expense_write_off_groups: "recharge_write_off/query_write_off_groups",
  update_expense_write_off_group: "recharge_write_off/update_write_off_group",
  delete_expense_write_off_item: "recharge_write_off/delete_write_off_item",
  // fin report
  get_fin_expense_types: "fin_expense_type/get_all",
  final_fin_expense_types: "fin_expense_type/final_types",
  get_fin_expense_manual_types: "fin_expense_type/manual_types",
  fin_v2_report_types: "fin_expense_type/v2_report_types",
  fin_expense_type_update: "fin_expense_type/update",
  fin_team_expense_manual_data: "fin_team_expense/manual_data",
  update_fin_team_expense_manual_data: "fin_team_expense/update_manual_data",
  // fin team period
  fin_team_period_list: "fin_team_period/list",
  update_fin_team_period: "fin_team_period/update",
  update_fin_team_month_period: "fin_team_period/update_month",
  fin_team_period_month_data: "fin_team_period/month_data",
  //expense group export log
  recent_expense_group_export: "expense_group_export_log/recent",
  reload_expense_group_export: "expense_group_export_log/reload",
  check_expense_group_export: "expense_group_export_log/check",
  expense_group_export_detail: "expense_group_export_log/detail",
  //expense group export check
  expense_group_export_check_list: "expense_group_export_check/list",
  expense_group_export_check_batch_finish:
    "expense_group_export_check/batch_finish",
  expense_group_export_check_delete: "expense_group_export_check/delete",
  //expense invoice
  update_expense_invoice: "expense/update_invoice",
  delete_expense_invoice: "expense_invoice/delete",
  query_expense_invoice_info_by_ids: "expense/query_invoice_info_by_ids",
  query_non_invoice_expenses: "expense/query_non_invoice_expenses",
  update_expense_no_need_statistic: "expense/update_no_need_statistic",
  update_expense_no_need_push: "expense/update_no_need_push",
  // asset
  query_asset: "asset/query",
  query_asset_by_id: "asset/query_by_id",
  query_customer_assets: "asset/query_customer_assets",
  asset_base_data: "asset/base_data",
  update_asset: "asset/update",
  update_asset_team: "asset/update_team",
  import_asset: `${ajaxUrl}/asset/import`,
  export_assets: `${ajaxUrl}/asset/export`,
  export_customer_assets: `${ajaxUrl}/asset/export_customer_assets`,
  generate_asset_expense_groups: "asset/generate_expense_groups",
  query_asset_search: "asset/query_search",
  asset_detail: "asset/detail",
  asset_query_mine_team: "asset/query_mine_team",
  asset_export_mine_team: `${ajaxUrl}/asset/export_mine_team`,
  asset_print_detail: `asset/detail_for_print`,
  // asset customer
  add_asset_customer: "asset_customer/add",
  delete_asset_customer: "asset_customer/delete",
  // asset name
  query_asset_name: "asset_name/query",
  update_asset_name: "asset_name/update",
  delete_asset_name: "asset_name/delete",
  // asset_order_name
  query_asset_order_name: "asset_order_name/query",
  update_asset_order_name: "asset_order_name/update",
  delete_asset_order_name: "asset_order_name/delete",
  // asset type
  query_asset_type: "asset_type/query",
  update_asset_type: "asset_type/update",
  // /asset/query_search
  asset_query_search: "asset/query_search",
  asset_order_complement: "asset_order/complement",
  // asset device type
  query_asset_device_type: "asset_device_type/query",
  update_asset_device_type: "asset_device_type/update",
  delete_asset_device_type: "asset_device_type/delete",
  // asset in out record
  query_asset_in_out_record: "asset_in_out_record/query",
  add_asset_in_out_record: "asset_in_out_record/add",
  add_asset_in_out_records: "asset_in_out_record/multiple_add",
  export_asset_in_out_record: `${ajaxUrl}/asset_in_out_record/export`,
  // asset brand
  query_asset_brand: "asset_brand/query",
  update_asset_brand: "asset_brand/update",
  delete_asset_brand: "asset_brand/delete",
  // asset location
  query_asset_location: "asset_location/query",
  update_asset_location: "asset_location/update",
  delete_asset_location: "asset_location/delete",
  // asset stock
  query_asset_stock: "asset_stock/query",
  update_asset_stock: "asset_stock/update",
  delete_asset_stock: "asset_stock/delete",
  // asset purpose
  query_asset_purpose: "asset_purpose/query",
  update_asset_purpose: "asset_purpose/update",
  delete_asset_purpose: "asset_purpose/delete",
  // asset_version
  query_asset_version: "asset_version/query",
  update_asset_version: "asset_version/save",
  delete_asset_version: "asset_version/delete",
  // asset_rule
  query_asset_rule_monthly_payee_company:
    "asset_rule_monthly_payee_company/query",
  update_asset_rule_monthly_payee_company:
    "asset_rule_monthly_payee_company/add",
  delete_asset_rule_monthly_payee_company:
    "asset_rule_monthly_payee_company/delete",
  query_all_asset_rule_monthly_payee_company:
    "asset_rule_monthly_payee_company/query_all",
  query_asset_rule_depreciate_price: "asset_rule_depreciate_price/query",
  update_asset_rule_depreciate_price: "asset_rule_depreciate_price/update",
  query_asset_rule_no_deduct_company: "asset_rule_no_deduct_company/query",
  update_asset_rule_no_deduct_company: "asset_rule_no_deduct_company/add",
  query_all_asset_device_type: "asset_device_type/query_all",
  query_asset_rule_no_depreciate_device_type:
    "asset_rule_no_depreciate_device_type/query",
  update_asset_rule_no_depreciate_device_type:
    "asset_rule_no_depreciate_device_type/add",
  delete_asset_rule_no_deduct_company: "asset_rule_no_deduct_company/delete",
  // asset_expense_teams
  query_asset_expense_team_by_asset_ids:
    "asset_expense_team/query_by_asset_ids",
  add_asset_expense_team: "asset_expense_team/add",
  delete_asset_expense_team: "asset_expense_team/delete",
  asset_inventory_create: "asset_inventory/create",
  asset_inventory_detail: "asset_inventory/detail",
  asset_inventory_check_asset: "asset_inventory/check_asset",
  asset_inventory_add_irregular_asset: "asset_inventory/add_irregular_asset",
  asset_inventory_list: "asset_inventory/list",
  asset_inventory_remove_irregular_asset:
    "asset_inventory/remove_irregular_asset",
  asset_inventory_delete: "asset_inventory/delete",
  asset_inventory_topic_list: "asset_inventory_topic/list",
  asset_inventory_topic_save: "asset_inventory_topic/save",
  asset_inventory_batch_pass_checked: "asset_inventory/batch_pass_checked",
  // purchase channel
  query_purchase_channel: "purchase_channel/query",
  update_purchase_channel: "purchase_channel/update",
  // invoice
  query_invoice: "invoice/query",
  update_generate_invoice: "invoice/update_generate_invoice",
  query_recent_generate_invoice_number:
    "invoice/query_recent_generate_invoice_number",
  invoice_detail: "invoice/detail",
  query_recent_invoice: "invoice/query_recent",
  update_invoice: "invoice/update",
  delete_invoice: "invoice/delete",
  import_invoice: "invoice/import_invoice",
  view_model_invoice: "invoice/view_model_invoice",
  get_invoice_picture: "invoice/picture",
  invoice_allot_balance: "invoice/allot_balance",
  ocr_invoice: ajaxUrl + "/invoice/ocr_invoice",
  ocr_audit: ajaxUrl + "/invoice/fill_in_by_xls",
  //export_invoice: ajaxUrl + '/invoice/export',
  // model invoice
  add_model_invoice: "model_invoice/add",
  add_model_rough_invoice: "model_invoice/add_rough",
  del_model_invoice: "model_invoice/del",
  allot_invoice_price: "model_invoice/allot_price",
  // rough invoice
  // contract
  contract_save: "contract/save",
  query_contract: "contract/query",
  contract_legal_audit_users: "contract/legal_audit_users",
  get_contract_brief: "contract/brief_info",
  es_query_contract: "contract/es_query",
  search_contract: "contract/search",
  contract_select_search: "contract/select_search",
  query_finished_contract: "contract/query_finished",
  query_mine_contract: "contract/query_mine",
  es_query_mine_contract: "contract/es_query_mine",
  query_contract_need_pay: "contract/query_need_pay",
  contract_noticed_finishing_list: "contract/noticed_finishing_list",
  contract_detail: "contract/detail",
  find_contract: "contract/find",
  update_contract: "contract/update",
  delete_contract: "contract/delete",
  close_contract: "contract/close",
  close_outsource_contract: "outsource_contract/close",
  contract_add_e_file_audit: "contract/add_e_file_audit",
  delete_link_contract: "contract/delete_link_contract",
  update_contract_files: "contract/update_files",
  contract_sync_to_kingdee: "contract/sync_to_kingdee",
  contract_update_need_at_payment_audit:
    "contract/update_need_at_payment_audit",
  contract_bill_generate_type: "contract/bill_generate_type",
  contract_check_add_payment: "contract/check_add_payment",
  // file stamp
  query_file_stamp: "file_stamp/query",
  update_status_file_stamp: "file_stamp/update_status",
  file_stamp_add_accessory: "file_stamp/add_accessory",
  file_stamp_download_list: `${ajaxUrl}/file_stamp/download_list`,
  // model_delegate
  add_model_delegate: "model_delegate/add",
  // export_contract: ajaxUrl + '/contract/export',
  // contract type
  get_contract_types: "contract_type/get_all",
  update_contract_type: "contract_type/update",
  contract_type_save: "contract_type/save",
  contract_type_list: "contract_type/list",
  expense_group_save: "expense_group/save",
  contract_type_change_status: "contract_type/change_status",
  // contract file
  delete_contract_file: "contract_file/delete",
  // outsource contract
  query_outsource_contract: "outsource_contract/query",
  query_my_outsource_contract: "outsource_contract/query_mine",
  outsource_contract_select_search: "outsource_contract/select_search",
  find_outsource_contract: "outsource_contract/find",
  update_outsource_wage_record_bank_info:
    "outsource_wage_record/update_bank_info",
  query_my_valid_outsource_contract: "outsource_contract/my_valid_contract",
  query_my_expired_outsource_contract: "outsource_contract/my_expired_contract",
  update_outsource_contract: "outsource_contract/update",
  delete_outsource_contract: "outsource_contract/delete",
  outsource_contract_detail: "outsource_contract/detail",
  outsource_contract_sign_remind: "outsource_contract/sign_remind",
  outsource_payee_company_account: "outsource_contract/payee_company_account",
  update_outsource_contract_archive_files:
    "outsource_contract/update_archive_files",
  outsource_contract_need_clear: "outsource_contract/need_clear",
  outsource_contract_save_final_contract:
    "outsource_contract/save_final_contract",
  outsource_contract_contract_revoke: "outsource_contract/contract_revoke",
  outsource_contract_contract_sign: "outsource_contract/contract_sign",
  // outsource wage
  add_outsource_wage_record: "director_outsource_wage_topic/add_wage_record",
  query_outsource_wage_topic: "outsource_wage_topic/query",
  my_outsource_wage_topic_record: "director_outsource_wage_topic/topic_record",
  team_outsource_wage_topic_detail_path: "outsource_wage_topic/team_detail",
  outsource_wage_topic_detail: "outsource_wage_topic/detail",
  outsource_wage_topic_update: "outsource_wage_topic/update",
  update_outsource_wage_topic_status: "outsource_wage_topic/update_status",
  outsource_wage_topic_batch_pay: "outsource_wage_topic/batch_pay",
  update_outsource_wage_records: "director_outsource_wage_topic/update_records",
  outsource_wage_topic_director_topics: "outsource_wage_topic/director_topics",
  del_outsource_wage_record: "outsource_wage_record/delete",
  update_outsource_wage: "outsource_wage_record/update",
  abandon_outsource_wage: "outsource_wage_record/abandon",
  recover_outsource_wage: "outsource_wage_record/recover",
  repay_outsource_wage: "outsource_wage_record/repay",
  update_director_outsource_topic_status:
    "director_outsource_wage_topic/update_status",
  update_director_outsource_topics_status:
    "director_outsource_wage_topic/update_topics_status",
  director_outsource_wage_records: "director_outsource_wage_topic/records",
  director_outsource_wage_topic_audit:
    "director_outsource_wage_topic/audit_topics",
  delete_director_outsource_wage_topic: "director_outsource_wage_topic/delete",
  recover_director_outsource_wage_topic:
    "director_outsource_wage_topic/recover",
  export_outsource_wage_topic_records_data:
    ajaxUrl + "/outsource_wage_topic/export_wage_data",
  export_outsource_wage_topic_records: ajaxUrl + "/outsource_wage_topic/export",

  // rec topic 推荐奖
  query_rec_award_topic: "rec_award_topic/query",
  update_rec_award_topic: "rec_award_topic/update",
  delete_rec_award_topic: "rec_award_topic/delete",
  rec_award_topic_detail: "rec_award_topic/detail",
  delete_rec_award_record: "rec_award_topic/delete_record",
  update_rec_award_record_alipay: "rec_award_record/update_alipay",
  repay_rec_award_record: "rec_award_record/repay",

  // user order
  query_user_order: "user_order/query",
  // offline_order
  get_mall_item_group_stocks: "offline_order/get_mall_item_group_stocks",
  list_offline_orders_path: "offline_order/list_offline_orders_path",
  offline_order_es_query: "offline_order/es_query",
  offline_order_es_query_mine: "offline_order/es_query_mine",
  add_apply_offline_order: "offline_order/add_apply_offline_order",
  offline_order_detail: "offline_order/detail",
  offline_order_del: "offline_order/delete",
  offline_batch_order_del: "offline_order/delete_batch",
  offline_order_close: "offline_order/close",
  offline_order_unified_team_list: "offline_order/get_unified_team_list",
  offline_batch_order_close: "offline_order/close_batch",
  import_batch_path: ajaxUrl + "/offline_order/import_batch_path",
  offline_order_batch_detail_path: "offline_order/offline_order_batch_detail",
  transport_detail: "offline_order/transport_detail",
  export_offline_order: `${ajaxUrl}/offline_order/export_offline_order`,

  // warehouse
  get_all_warehouses: "warehouse/all",
  update_warehouse: "warehouse/update",
  // shop
  get_all_shops: "shop/all",
  update_shop: "shop/update",
  // stock
  query_stock: "stock/query",
  stock_detail: "stock/detail",
  update_stock: "stock/update",
  es_query_stock: "stock/es_query",
  es_query_parent_stock: "stock/es_query_parent",
  es_query_online_stock: "stock/es_query_online_stock",
  es_query_my_stock: "stock/es_query_mine",
  del_my_stock: "stock/delete",
  create_stock_barcode_apply: "stock_barcode_apply/create",
  es_query_stock_indicators: "stock/es_query_stock_indicators",
  stock_qty: "stock/stock_qty",
  stock_teams: "stock/teams",
  stock_contracts: "stock/contracts",
  stock_out_data: "stock/out_data",
  stock_inventory_data: "stock/inventory_data_daily",
  stock_barcode_validate: "stock/barcode_validate",
  export_stock_indicator: `${ajaxUrl}/stock/export_indicator`,
  // stock alert
  update_stock_alert: "stock_alert/update",
  // stock_dosage
  delete_stock_dosage: "stock_dosage/delete",
  // contract stock
  delete_contract_stock: "contract_stock/delete",
  query_contract_stock: "contract_stock/list",
  update_contract_stock_status: "contract_stock/update_status",
  // stock in record
  update_stock_in_record: "stock_in_record/update",
  query_stock_in_record: "stock_in_record/query",
  query_stock_arrived: "stock_in_record/arrived",
  stock_in_order_detail: "stock_in_order/detail",
  query_contract_stock_status: "stock_in_order/query_contract_stock_status",
  // stock in order item
  del_stock_in_order_item: "stock_in_order_item/delete",
  // stock unit
  get_all_stock_unit: "stock_unit/get_all",
  // tax code
  query_tax_code: "tax_code/query",
  update_tax_code: "tax_code/update",
  // tax rate
  get_all_tax_rate: "tax_rate/get_all",
  // product type
  product_type_tree_info: "product_type/tree_info",
  product_type_leaf_info: "product_type/leaf_info",
  update_product_type: "product_type/update",
  // stock period cost
  import_stock_period_cost: `${ajaxUrl}/stock_period_cost/import`,
  query_stock_period_cost: "stock_period_cost/query",
  // stock online
  query_mall_item: "mall_item/es_query",
  query_mine_mall_item: "mall_item/es_query_mine",
  mall_online_item_detail: "mall_item/online_item_detail",
  mall_online_item_edit_info: "mall_item/online_item_edit_info",
  mall_item_diff_info: "mall_item/diff_info",
  mall_channel_list: "mall_item/channel_list",
  update_mall_online_item: "mall_item/update",
  del_mall_online_item: "mall_item/del_online_item",
  upload_mall_file: ajaxUrl + "/mall_item/upload_file",
  upload_mall_kind_editor_file: ajaxUrl + "/mall_item/upload_kind_editor_file",
  mall_pledge_tags_list: "mall_item/pledge_tags_list",
  get_sts: "mall_item/get_sts",
  // travel order
  update_travel_order: "travel_order/update",
  query_mine_travel_order: "travel_order/query_mine",
  query_mine_travel_order_item: "travel_order/query_mine_item",
  query_travel_order: "travel_order/query",
  delete_travel_order: "travel_order/delete",
  delete_travel_order_item: "travel_order/delete_item",
  delete_travel_order_item_customer: "travel_order/delete_item_customer",
  update_travel_order_item_info: "travel_order/update_item_info",
  export_travel_order: `${ajaxUrl}/travel_order/export`,
  // dir and file
  file_upload_path: ajaxUrl + "/bfile/upload_to_oss",
  attachment_upload_path: ajaxUrl + "/bfile/upload_attachment",
  public_attachment_upload_path: ajaxUrl + "/bfile/upload_public_attachment",
  upload_to_oss_public: ajaxUrl + "/upload_to_oss_public",
  update_file: "bfile/update",
  download_file: "bfile/oss_url",
  download_attachment: "bfile/attachment_url",
  delete_file: "bfile/delete",
  query_dir_and_file: "bfile/query",
  file_shares: "bfile/share_customers",
  add_customer_to_file: "bfile/add_share_customer",
  delete_customer_from_file: "bfile/delete_share_customer",
  delete_model_file: "bfile/delete_model_file",
  // flow node edge
  query_flow: "flow/query",
  all_flow: "flow/all",
  flow_edit_info: "flow/get_edit_info",
  flow_with_node_teams: "flow/info_with_node_teams",
  get_flow_by_link_model: "flow/get_by_link_model",
  update_flow: "flow/update",
  update_flow_hooks: "flow/update_hooks",
  update_flow_detail_path: "flow/update_detail_path",
  flow_pending_count: "flow/pending_count",
  flow_real_time_states: "flow/real_time_states",
  flow_states: "flow/states",
  flow_update_states: "flow/update_states",
  flow_node_user_states: "flow_node_user/states",
  flow_node_user_unusual_order_list: "flow_node_user/unusual_order_list",
  get_new_node: "flow_node/new",
  get_new_edge: "flow_edge/new",
  update_node: "flow_node/update",
  update_edge: "flow_edge/update",
  delete_node: "flow_node/delete",
  delete_edge: "flow_edge/delete",
  pass_user_flow_node_user: "user_flow_node_user/pass",
  batch_pass_user_flow_node_user: "user_flow_node_user/batch_pass",
  fail_user_flow_node_user: "user_flow_node_user/fail",
  invite_user_flow_node_user: "user_flow_node_user/invite",
  transfer_user_flow_node_user: "user_flow_node_user/transfer",
  hold_user_flow_node_user: "user_flow_node_user/hold",
  batch_transfer_user_flow_node_user: "user_flow_node_user/batch_transfer",
  query_user_flow_node_user: "user_flow_node_user/query",
  user_flow_detail: "user_flow/detail",
  user_flow_base: "user_flow/base",
  add_user_flow_link_user: "user_flow/add_link_user",
  add_flow_condition: "flow_condition/add",
  update_flow_condition: "flow_condition/update",
  delete_flow_condition: "flow_condition/delete",
  add_flow_node_user: "flow_node/add_node_user",
  update_flow_node_user: "flow_node_user/update",
  delete_flow_node_user: "flow_node_user/delete",
  update_flow_node_email: "flow_node/update_node_email",
  update_flow_node_hooks: "flow_node/update_hooks",
  update_flow_node_key_name: "flow_node/update_key_name",
  update_flow_node_color: "flow_node/update_node_color",
  update_flow_node_need_statistic: "flow_node/update_node_need_statistic",
  update_flow_node_team: "flow_node/update_node_team",
  // 流程转移
  flow_transfer_query: "user_flow_transfer_config/query",
  flow_transfer_del: "user_flow_transfer_config/delete",
  flow_transfer_save: "user_flow_transfer_config/save",

  // fin report 财务报表相关
  fin_report_time_range: "fin_report/time_range",
  fin_report_date_range: "fin_report/date_range",
  fin_report_month_report: "fin_report/month_report",
  fin_report_dynamic_income: "fin_report/dynamic_income",
  expense_pool_team_brief_info: "expense_pool/team_brief_info",
  expense_pool_team_pool_info: "expense_pool/team_expense_pool_info",
  expense_pool_team_study_info: "expense_pool/team_expense_study_info",
  budget_order_change_important: "budget_order/change_important",
  // course 课程
  get_courses: "course/list",
  update_course: "course/update",
  // course data
  chart_courses_and_types: "course_data/chart_courses_and_types",
  course_manual_data: "course_data/manual_data",
  course_term_data: "course_data/term_data",
  course_offset_data: "course_data/offset_data",
  course_month_data: "course_data/month_data",
  course_chart_data: "course_data/chart_data",
  max_course_term: "course_data/max_term",
  update_course_manual_data: "course_data/update_manual_data",
  update_manual_course_data: "course_data/update_manual_course_data",
  // course data type
  get_course_data_types: "course_data_type/list",
  update_course_data_type: "course_data_type/update",
  // tag
  add_tag: "tag/add",
  // wiki
  query_wiki: "wiki/query",
  update_wiki: "wiki/update",
  wiki_detail: "wiki/detail",
  add_wiki_tag: "wiki/add_tag",
  del_wiki_tag: "wiki/del_tag",
  delete_wiki_file: "wiki/del_file",
  // wage 正式员工工资
  update_wage_record: "wage/update_record",
  wage_records: "wage/records",
  wage_records_with_comment: "wage/records_with_comment",
  my_records: "wage/my_records",
  comment_wage_record: "wage/comment",
  wage_admin_verify_code: "wage/admin_verify_code",
  wage_verify_code: "wage/verify_code",
  wage_items: "wage/items",
  // option
  import_option: "customer_option/import",
  option_sms_admin_code:
    "https://mis_option.baicizhan.com/customer_option/send_admin_sms",
  //my_option: 'https://mis_option.baicizhan.com/customer_option/my_option',
  bcz_options: "https://mis_option.baicizhan.com/customer_option/options",

  option_sms_code: "customer_option/send_sms",
  check_has_option: "customer_option/has_option",
  get_options: "customer_option/options",
  my_option: "customer_option/my_option",
  update_customer_option: "customer_option/update",
  delete_customer_option: "customer_option/delete",
  my_option_order: "option_order/mine",
  get_option_orders: "option_order/orders",
  submit_option_order: "option_order/submit",
  delete_option_order: "option_order/delete",
  option_order_customers: "option_order/customers",
  export_option_orders: ajaxUrl + "/option_order/export",
  // bonus reward
  import_bonus: "bonus_reward/import",
  get_bonus: "bonus_reward/get",
  // comment
  get_comments: "comment/model_list",
  update_comment: "comment/update",
  // yunzhanghu
  query_expense_payment_records: "expense_payment_record/query",
  query_expense_payment_repay_records: "expense_payment_record/query_repay",
  repay_expense_payment_record: "expense_payment_record/repay",
  abandon_expense_payment_record: "expense_payment_record/abandon",
  // export
  export_list: "export/list",
  export_file_url: "export/file_url",
  export_customer: "export/customer",
  export_expense_write_off: "export/expense_write_off",
  export_invoice: "export/invoice",
  export_invoice_list: "export/invoice_list",
  export_contract: "export/contract",
  export_outsource_contract: "export/outsource_contract",
  export_wage_record: "export/wage_record",
  export_recruit_need: "export/recruit_need",
  //sms log
  get_sms_logs: "sms_log/query",
  get_email_logs: "email_log/query",
  get_commit_logs: "commit_log/query",
  retry_sms: "sms_log/retry",
  batch_send_sms: "sms_log/batch_send",
  //export
  export_informal_wage_topic_records_data:
    ajaxUrl + "/informal_wage_topic/export_wage_data",
  import_informal_wage_topic_records_data:
    ajaxUrl + "/informal_wage_topic/import_wage_data",
  export_expense_group: "export/expense_group",
  export_expense_group_invoice_check: "export/expense_group_invoice_check",
  export_expense_group_company_to_pay:
    ajaxUrl + "/expense_group/export_company_to_pay",
  export_expense_group_customer_to_pay:
    ajaxUrl + "/expense_group/export_customer_to_pay",
  export_expense_group_outsource_bank_to_pay:
    ajaxUrl + "/expense_group/export_outsource_bank_to_pay",
  export_expense_group_outsource_alipay_to_pay:
    ajaxUrl + "/expense_group/export_outsource_alipay_to_pay",
  // kingdee sync
  kingdee_sync_query: "kingdee_sync/query",
  kingdee_sync_retry: "kingdee_sync/retry",
  kingdee_sync_force_success: "kingdee_sync/force_success",
  kingdee_sync_failed_count: "kingdee_sync/failed_count",
  kingdee_sync_out_stock_query: "kingdee_sync/out_stock_query",
  kingdee_sync_split_out_stock_query: "kingdee_sync/split_out_stock_query",
  kingdee_sync_out_stock_detail: "kingdee_sync/out_stock_detail",
  kingdee_sync_kingdee_del: "kingdee_sync/kingdee_del",
  // event notice
  event_notice_detail: "event_notice/detail",
  event_types: "event_notice/event_types",
  query_event_notice: "event_notice/query",
  update_event_notice: "event_notice/update",
  // rule
  query_rule: "rule/query",
  update_rule: "rule/update",

  // model name
  query_model_name: "model/query",

  // asset customer operate
  query_asset_customer_operate: "asset_customer_operate/query",
  add_asset_customer_operate: "asset_customer_operate/add",
  update_asset_stock_asset_customer_operate:
    "asset_customer_operate/update_asset_stock",
  delete_asset_customer_operate: "asset_customer_operate/delete",
  asset_customer_operate_export: "asset_customer_operate/export",
  // asset customer operate
  asset_customer_operate_detail: "asset_customer_operate/detail",
  update_asset_customer_remark: "asset_customer_remark/update",
  // asset order
  update_asset_order: "asset_order/update",
  add_asset_order: "asset_order/add",
  query_mine_asset_order: "asset_order/query_mine",
  delete_asset_order: "asset_order/delete",
  query_mine_asset: "asset/query_mine",
  asset_order_detail: "asset_order/detail",
  // power bi
  power_bi_access_token: "power_bi/access_token",
  // 获取
  route_app_auth_info: "route_app/auth_info",
  // 法务
  qualification_subject_list: "qualification/subject_list",
  qualification_update_subject: "qualification/update_subject",
  qualification_change_subject_status: "qualification/change_subject_status",
  qualification_histories_versions: "qualification/histories_versions",
  qualification_update: "qualification/update",
  qualification_create: "qualification/create",
  qualification_item_list: "qualification/item_list",
  qualification_change_status: "qualification/change_status",
  qualification_file_url: "qualification/file_url",
  qualification_order_list: "qualification_order/list",
  qualification_order_upload_stamped_file:
    "qualification_order/upload_stamped_file",
  qualification_order_mine_list: "qualification_order/mine_list",
  qualification_order_download_finished_url:
    "qualification_order/download_finished_url",
  qualification_order_qualification_list:
    "qualification_order/qualification_list",
  qualification_order_create: "qualification_order/create",
  qualification_order_update: "qualification_order/update",
  qualification_order_delete: "qualification_order/delete",
  // 科目相关设置
  expense_nature_list: "expense_nature/list",
  expense_nature_save: "expense_nature/save",
  expense_nature_diable: "expense_nature/change_status",
  customer_function_list: "customer_function/list",
  customer_function_save: "customer_function/save",
  customer_function_delete: "customer_function/change_status",
  item_type_list: "item_type/list",
  item_type_save: "item_type/save",
  item_type_delete: "item_type/change_status",
  account_title_all: "account_title/all",
  account_title_save: "account_title/save",
  account_title_change_status: "account_title/change_status",
  analysis_title_list: "analysis_title/all",
  analysis_title_save: "analysis_title/save",
  analysis_title_change_status: "analysis_title/change_status",
  fund_usage_list: "fund_usage/list",
  fund_usage_save: "fund_usage/save",
  fund_usage_change_status: "fund_usage/change_status",

  // 科目映射表
  title_mapping_query: "title_mapping/query",
  title_mapping_update: "title_mapping/update",
  title_mapping_change_status: "title_mapping/change_status",
  title_mapping_export: `${ajaxUrl}/title_mapping/export`,
  // 预算申请
  budget_order_create: "budget_order/create",
  budget_order_list: "budget_order/list",
  budget_order_update: "budget_order/update",
  budget_order_detail: "budget_order/detail",
  budget_order_create_sub_order: "budget_order/create_sub_order",
  budget_order_sub_order_detail: "budget_order/sub_order_detail",
  budget_order_update_sub_order: "budget_order/update_sub_order",
  budget_order_delete_sub_order: "budget_order/delete_sub_order",
  budget_order_mine_list: "budget_order/mine_list",
  budget_order_full_detail: "budget_order/full_detail",
  budget_order_delete: "budget_order/delete",
  budget_amount_quarter_amount: "budget_amount/quarter_amount",
  // 应收单
  fin_receivable_bill_query: "fin_receivable_bill/query",
  fin_receivable_bill_items: "fin_receivable_bill/items",
  fin_receivable_bill_update: "fin_receivable_bill/update",
  fin_receivable_bill_create: "fin_receivable_bill/create",
  fin_receivable_bill_delete: "fin_receivable_bill/delete",
  fin_receivable_bill_detail: "fin_receivable_bill/detail",
  // 收款单
  fin_receipt_bill_query: "fin_receipt_bill/query",
  fin_receipt_bill_items: "fin_receipt_bill/items",
  fin_receipt_bill_update: "fin_receipt_bill/update",
  fin_receipt_bill_create: "fin_receipt_bill/create",
  fin_receipt_bill_delete: "fin_receipt_bill/delete",
  fin_receipt_bill_detail: "fin_receipt_bill/detail",
  fin_receipt_bill_transform_to_accrual:
    "fin_receipt_bill/transform_to_accrual",
  // 收款计提单
  fin_receipt_accrual_bill_query: "fin_receipt_accrual_bill/query",
  fin_receipt_accrual_bill_items: "fin_receipt_accrual_bill/items",
  fin_receipt_accrual_bill_update: "fin_receipt_accrual_bill/update",
  fin_receipt_accrual_bill_create: "fin_receipt_accrual_bill/create",
  fin_receipt_accrual_bill_delete: "fin_receipt_accrual_bill/delete",
  fin_receipt_accrual_bill_detail: "fin_receipt_accrual_bill/detail",
  // 费用拆分单
  fin_fee_distribute_bill_query: "fin_fee_distribute_bill/query",
  fin_fee_distribute_bill_items: "fin_fee_distribute_bill/items",
  // 消息群发
  group_send_add: "group_send_message/add",
  group_send_list: "group_send_message/list",

  // 银行流水查看三单

  // 消耗计划
  cost_plan_bill_es_query: "cost_plan_bill/es_query",
  cost_plan_bill_generate: "cost_plan_bill/generate",
  cost_plan_bill_detail: "cost_plan_bill/detail",
  cost_plan_bill_update: "cost_plan_bill/update",
  cost_plan_bill_change_status: "cost_plan_bill/change_status",
  cost_plan_update: "cost_plan/update",
  cost_plan_entry_delete: "cost_plan_entry/delete",
  cost_plan_team_delete: "cost_plan_team/delete",

  // payee_company_account/select_search
  payee_company_account_select_search: "payee_company_account/select_search",
  // 申请开店
  opening_shop_order_save: "opening_shop_order/save",
  opening_shop_order_query_mine: "opening_shop_order/query_mine",
  opening_shop_order_detail: "opening_shop_order/detail",
  opening_shop_order_query: "opening_shop_order/query",
  opening_shop_order_shop_order_list: "opening_shop_order/shop_order_list",
  third_party_shop_query: "third_party_shop/query",
  third_party_shop_save: "third_party_shop/save",
  third_party_shop_modify_status: "third_party_shop/modify_status",
  // 财务核算组
  audit_customer_model_audit_models: "audit_customer_model/audit_models",
  audit_customer_model_save: "audit_customer_model/save",
  bank_statement_reconciliation: "bank_statement/reconciliation",
  // hr的接口
  // hr_wxdata_financial_clock_in_data_of_customer: 'hr/wxdata/financial/clock_in_data_of_customer',

  // 薪资发放 相关
  customer_month_salary_total_list: "customer_month_salary_total/list",
  customer_basic_salary_info_page: "customer_basic_salary/info_page",
  customer_basic_salary_info_detail: "customer_basic_salary/info_detail",
  customer_basic_salary_update_salary: "customer_basic_salary/update_salary",
  customer_basic_salary_batch_update_salary:
    "customer_basic_salary/batch_update_salary",
  customer_basic_salary_history_list: "customer_basic_salary/history_list",
  customer_basic_salary_save_insurance_change_info:
    "customer_basic_salary/save_insurance_change_info",
  customer_basic_salary_insurance_change_history:
    "customer_basic_salary/insurance_change_history",
  customer_insurance_payment_base_get_base:
    "customer_insurance_payment_base/get_base",
  customer_insurance_payment_base_update_base:
    "customer_insurance_payment_base/update_base",
  customer_insurance_payment_ratio_get_ratio:
    "customer_insurance_payment_ratio/get_ratio",
  customer_insurance_payment_ratio_update_ratio:
    "customer_insurance_payment_ratio/update_ratio",
  customer_salary_adjust_apply_save: "customer_salary_adjust_apply/save",
  customer_salary_adjust_apply_search: "customer_salary_adjust_apply/search",
  customer_month_salary_total_download_detail:
    "customer_month_salary_total/download_detail",
  customer_month_salary_total_cost_trend:
    "customer_month_salary_total/cost_trend", // 费用趋势
  customer_month_salary_total_cost_statistics:
    "customer_month_salary_total/cost_statistics",
  customer_month_salary_total_detail_list:
    "customer_month_salary_total/detail_list",
  customer_month_salary_total_detail_count:
    "customer_month_salary_total/detail_count",
  customer_month_salary_total_modify_detail:
    "customer_month_salary_total/modify_detail",
  customer_month_salary_total_pigeonhole:
    "customer_month_salary_total/pigeonhole",
  customer_meal_subsidy_list: "customer_meal_subsidy/list",
  customer_meal_subsidy_update: "customer_meal_subsidy/update",
  customer_month_salary_total_recommend_award_detail:
    "customer_month_salary_total/recommend_award_detail",
  customer_month_salary_total_import_salary_detail_info:
    "customer_month_salary_total/import_salary_detail_info",
  customer_month_salary_total_current_month_pay:
    "customer_month_salary_total/current_month_pay",
  customer_month_salary_total_company_month_salary_info:
    "customer_month_salary_total/company_month_salary_info",
  customer_month_salary_total_down_import_templete:
    "customer_month_salary_total/down_import_templete",
  hr_cost_cost_statistics: "hr/cost/cost_statistics_download_of_mis",
  // 经常性支付列表
  often_payment_list: "/customer_often_payment/list",
  often_payment_del: "/customer_often_payment/delete",
  often_payment_save: "/customer_often_payment/save",
  //  http://localhost:8080/api/hr/cost/cost_statistics_download?type=100

  // bank_statement_reconciliation: 'bank_statement/reconciliation',
  // hr的接口
  hr_wxdata_financial_clock_in_data_of_customer:
    "hr/wxdata/financial/clock_in_data_of_customer",
  hr_wxdata_financial_intern_salary_of_customer:
    "hr/wxdata/financial/intern_salary_of_customer",
  hr_wxdata_financial_intern_salary_of_customer_new:
    "hr/wxdata/financial/intern_salary_of_customer_new",
  // hr_wxdata_financial_clock_in_data_of_customer: 'hr/wxdata/financial/clock_in_data_of_customer',
  cash_balance_synchro_current_balance: "cash_balance/synchro_current_balance",
  cash_balance_query_page: "cash_balance/query_page",
  cash_balance_import: "cash_balance/import",
  release_note_list: "release_note/list",

  group_finance_balance_monthly_ledger_query:
    "group_finance_balance_monthly_ledger/query",
  group_finance_statement_monthly_ledger_query:
    "group_finance_statement_monthly_ledger/query",
  account_finance_balance_monthly_ledger_query_difference:
    "account_finance_balance_monthly_ledger/query_difference",
  group_finance_statement_monthly_ledger_query_flow_difference:
    "group_finance_statement_monthly_ledger/query_flow_difference",
  group_finance_statement_monthly_ledger_query_order_difference:
    "group_finance_statement_monthly_ledger/query_order_difference",
  group_finance_statement_monthly_ledger_export_difference:
    "group_finance_statement_monthly_ledger/export_difference",
  group_finance_safe_monthly_ledger_query:
    "group_finance_safe_monthly_ledger/query",
  group_finance_safe_monthly_ledger_save:
    "group_finance_safe_monthly_ledger/save",
  group_finance_income_monthly_ledger_query:
    "group_finance_income_monthly_ledger/query",
  group_finance_balance_monthly_ledger_refresh_all:
    "group_finance_balance_monthly_ledger/refresh_all",
  group_finance_balance_monthly_ledger_check:
    "group_finance_balance_monthly_ledger/check",
  group_finance_balance_monthly_ledger_month_refresh_all:
    "group_finance_balance_monthly_ledger/month_refresh_all",
  company_account_period_query: "company_account_period/query",
  company_account_period_create: "company_account_period/create",
  company_account_period_update_flag: "company_account_period/update_flag",
  ams_account_search: "ams/account/search",
  dimission_wage_list: "dimission_wage/list",
  dimission_wage_save: "dimission_wage/save",
  dimission_wage_delete: "dimission_wage/delete",
  route_group_all: "route_group/all",
  route_group_customers: "route_group/customers",
  // kol
  placing_ads_kol_query: "placing_ads_kol/query",
  placing_ads_kol_save: "placing_ads_kol/save",
  placing_ads_kol_owner_query: "placing_ads_kol/owner_query",
  placing_ads_kol_decrypt_auth_code_apply:
    "placing_ads_kol_decrypt_auth_code/apply",
  placing_ads_kol_decrypt_auth_code_check_and_decrypt:
    "placing_ads_kol_decrypt_auth_code/check_and_decrypt",
  placing_ads_sku_list: "placing_ads_sku/list",
  placing_ads_sku_all: "placing_ads_sku/all",
  placing_ads_sku_save: "placing_ads_sku/save",
  placing_ads_sku_change_status: "placing_ads_sku/change_status",
  placing_ads_kol_list: "placing_ads_kol/list",
  placing_ads_record_save: "placing_ads_record/save",
  placing_ads_record_query: "placing_ads_record/query",
  placing_ads_record_detail: "placing_ads_record/detail",
  placing_ads_vas_record_save: "placing_ads_vas_record/save",
  placing_ads_vas_record_delete: "placing_ads_vas_record/delete",
  placing_ads_record_delete: "placing_ads_record/delete",
  placing_ads_record_select_search: "placing_ads_record/select_search",
  expense_group_add_placing_ads: "expense_group/add_placing_ads",
  expense_group_save_placing_records: "expense_group/save_placing_records",
  expense_group_related_placing_records:
    "expense_group/related_placing_records",
  expense_group_delete_placing_records: "expense_group/delete_placing_records",
  expense_group_import_expense: "expense_group/import_expense",
  placing_ads_vas_record_select_search: "placing_ads_vas_record/select_search",
  placing_ads_record_export: "placing_ads_record/export",
  placing_ads_record_import: "placing_ads_record/import",
  placing_ads_kol_export: "placing_ads_kol/export",
  placing_ads_kol_delete: "placing_ads_kol/delete",
  placing_ads_kol_add_enjoy_customer: "placing_ads_kol/add_enjoy_customer",
  placing_ads_kol_delete_enjoy_customer:
    "placing_ads_kol/delete_enjoy_customer",
  expense_group_export_placing_records_payee_info:
    "expense_group/export_placing_records_payee_info",
  enum_config_list: "enum_config/list",
  enum_config_add: "enum_config/add",
  enum_config_update: "enum_config/update",
  enum_config_change_status: "enum_config/change_status",

  spider_placing_rank: "market/xhs/exposure/list",

  placing_ads_record_close: "placing_ads_record/close",
  placing_ads_kol_detail: "placing_ads_kol/detail",
  placing_ads_kol_mark_risk_kol: "placing_ads_kol/mark_risk_kol",
  contract_related_placing_records: "contract/related_placing_records",
  outsource_contract_related_placing_records:
    "outsource_contract/related_placing_records",
  contract_delete_placing_record: "contract/delete_placing_record",
  contract_save_placing_record: "contract/save_placing_record",
  outsource_contract_delete_placing_record:
    "outsource_contract/delete_placing_record",
  outsource_contract_save_placing_record:
    "outsource_contract/save_placing_record",
  kol_contract_info_search: "kol_contract_info/search",
  kol_contract_info_supply_contract_info:
    "kol_contract_info/supply_contract_info",
  kol_contract_info_create_outsource_contract:
    "kol_contract_info/create_outsource_contract",
  third_part_mall_sub_item: "third_party/mall/sub_item",
  customer_expense_type_customer_title_mappings:
    "customer_expense_type/customer_title_mappings",
  customer_expense_type_query: "customer_expense_type/query",
  customer_expense_type_update: "customer_expense_type/update",
  salary_job_sequence_tree_info: "salary_job_sequence/tree_info",
  salary_job_sequence_save: "salary_job_sequence/save",
  outsource_contract_title_mapping_save:
    "outsource_contract_title_mapping/save",
  outsource_contract_title_mapping_query:
    "outsource_contract_title_mapping/query",
  outsource_contract_title_mapping_delete:
    "outsource_contract_title_mapping/delete",
  salary_mapping_save: "salary_mapping/save",
  salary_mapping_list: "salary_mapping/list",
  salary_mapping_add_title_mapping: "salary_mapping/add_title_mapping",
  salary_mapping_remove_title_mapping: "salary_mapping/remove_title_mapping",
  sales_customer_function_mapping_query:
    "sales_customer_function_mapping/query",
  sales_customer_function_mapping_change_status:
    "sales_customer_function_mapping/change_status",
  sales_customer_function_mapping_save: "sales_customer_function_mapping/save",
  customer_basic_salary_confirm: "customer_basic_salary/confirm",
  customer_basic_salary_import_basic_salary:
    "customer_basic_salary/import_basic_salary",
  customer_salary_adjust_batch_template:
    "customer_salary_adjust/batch_template",
  customer_salary_adjust_apply_batch_apply_save:
    "customer_salary_adjust_apply/batch_apply_save",
  customer_salary_adjust_apply_delete: "customer_salary_adjust_apply/delete",
  customer_salary_payment_apply_delete: "customer_salary_payment_apply/delete",
  customer_salary_adjust_apply_down_batch_adjust:
    "customer_salary_adjust_apply/down_batch_adjust",
  customer_salary_adjust_apply_detail: "customer_salary_adjust_apply/detail",
  customer_basic_salary_init_import_template:
    "customer_basic_salary/init_import_template",
  customer_salary_payment_apply_search: "customer_salary_payment_apply/search",
  customer_month_salary_total_down_init_template_file:
    "customer_month_salary_total/down_init_template_file",
  customer_month_salary_total_import_init_data:
    "customer_month_salary_total/import_init_data",
  customer_month_salary_total_transfer_wage:
    "customer_month_salary_total/transfer_wage",
  customer_basic_salary_need_confirm_list:
    "customer_basic_salary/need_confirm_list",
  customer_month_salary_total_pay_salary:
    "customer_month_salary_total/pay_salary",
  customer_basic_salary_rebut: "customer_basic_salary/rebut",
  ams_platform_list: "ams/platform/list",
  ams_common_login_methods: "ams/common/login_methods",
  epop_account_query: "epop_account/query",
  ams_account: "ams/account",
  epop_account_select_search: "epop_account/select_search",
  epop_account_update: "epop_account/update",
  epop_account_share_save_config: "epop_account_share/save_config",
  epop_account_share_list_config: "epop_account_share/list_config",
  epop_account_detail: "epop_account/detail",
  epop_monthly_record_add_screenshot: "epop_monthly_record/add_screenshot",
  epop_monthly_record_import_consume: "epop_monthly_record/import_consume",
  epop_monthly_record_add_unusual_change:
    "epop_monthly_record/add_unusual_change",
  epop_monthly_record_remove_unusual_change:
    "epop_monthly_record/remove_unusual_change",
  epop_monthly_record_export_consume: "epop_monthly_record/export_consume",
  epop_account_mine_query: "epop_account/query_mine",
  epop_monthly_record_update: "epop_monthly_record/update",
  epop_account_share_delete_config: "epop_account_share/delete_config",
  placing_ads_record_query_for_transfer:
    "placing_ads_record/query_for_transfer",
  placing_ads_record_transfer: "placing_ads_record/transfer",
  placing_ads_kol_query_for_transfer: "placing_ads_kol/query_for_transfer",
  placing_ads_kol_transfer: "placing_ads_kol/transfer",
  // payee_company_account/select_search

  // 投放评价
  placing_ads_record_change_put_grade: "placing_ads_record/change_put_grade",

  third_party_shop_transfer_records: "third_party_shop/transfer_records",
  third_party_shop_export: "third_party_shop/export",
  closing_shop_order_save: "closing_shop_order/save",
  // SPU 管理
  cya_spu_query: "cya_spu/query",
  cya_spu_save: "cya_spu/save",
  cya_spu_save_application: "cya_spu/save_application",
  cya_spu_detail: "cya_spu/detail",
  cya_spu_chage_status: "cya_spu/change_status",
  cya_spu_select_search: "cya_spu/select_search",
  cya_spu_select_edition: "cya_spu/select_edition",
  // SPU销服成本分配
  SPU_COST_ALLOCATION_QUERY: "spu_cost_ratio/query",
  SPU_COST_ALLOCATION_IMPORT: "spu_cost_ratio/import",
  SPU_COST_ALLOCATION_DOWNLOAD: "spu_cost_ratio/down_template_file",
  SPU_COST_ALLOCATION_INFO_QUERY: "spu_cost_info/query",
};
